import React, { ReactNode } from 'react';
interface ActionProps {
  label: string;
  type: 'button' | 'submit' | 'reset';
  buttonType: string;
  onClick?: () => void;
  icon?: ReactNode;
  disabled?: boolean;
}
const Button = (props: ActionProps) => {
  const { label, onClick, type, buttonType, icon, disabled } = props;
  const actionColor = () => {
    switch (buttonType) {
      case 'primary':
        return 'bg-sky-700 text-white';
      case 'danger':
        return 'bg-[red] text-white';
      case 'warning':
        return 'bg-yellow-400 text-white';
      case 'success':
        return 'bg-[green] text-white';
      case 'primary-pro':
        return 'bg-white text-blue-500 border-blue-500 border';
      default:
        return 'bg-sky-700';
    }
  };
  const buttonLabel = (lable: string) => {
    return lable.charAt(0).toUpperCase() + label.slice(1);
  };
  return (
    <button
      data-testid="button-wrapper"
      disabled={disabled}
      type={type}
      className={`${actionColor()} py-1 px-4 rounded-sm shadow-md flex items-center text-sm ${
        disabled && 'pointer-events-none opacity-50'
      }`}
      onClick={onClick}
    >
      {icon && <div className="mr-1">{icon}</div>}
      <div className="text-sm" data-testid="button-label">
        {buttonLabel(label)}
      </div>
    </button>
  );
};

export default Button;
